import { Carousel, GenericLink, useBreakpoint, Breakpoints } from '@nextgen-web-framework/all';
import type { CardCategoryProps, ShopByCategoryProps } from './types/propsTypes';
import CardCategory from './CardCategory';
import styles from './ShopByCategory.module.scss';

const ShopByCategory = (props: ShopByCategoryProps) => {
  const viewPortType = useBreakpoint() as Breakpoints;
  return (
    <div
      className={`${styles['shop-by-category-wrapper']} ${props.containerClassName}`}
      data-testid={'shop-by-category-test-id'}
    >
      {!props.hideHeader && (
        <div className={styles['shop-by-category-title-info']}>
          <div className={styles['shop-by-category-title-container']}>
            <h4 className={styles['shop-by-category-title']}>{props.displayTitle}</h4>
            {props.link.text && (
              <div className={styles['shop-by-category-view-all']}>
                <GenericLink href={props.link.url} forceNative={false} target={props.link.target}>
                  {props.link.text}
                </GenericLink>
              </div>
            )}
          </div>
        </div>
      )}
      <div className={styles['shop-by-category-carousel-container']}>
        <Carousel
          id={'Shop-By-Category-Carousel'}
          hideButtons={[Breakpoints.XS, Breakpoints.SM].includes(viewPortType)}
          isTileCarousel={true}
        >
          {props.cardCategoryData?.map((item: CardCategoryProps) => (
            <CardCategory
              key={`${item.title}`}
              imagesData={item.imagesData}
              title={item.title}
              cardLinkData={item.cardLinkData}
            />
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default ShopByCategory;
export type { ShopByCategoryProps };
